import React, { useContext } from 'react';
import flush from 'just-flush';
import { HorizontalMasonryGallery } from '@stereoagency/ui';
import type { ILazyBlocksImage } from '@/types';
import { useMediaItems } from '@/hooks';
import { LinesContext } from '@/components/LinesContext';

type Props = {
  data: {
    variant?: 'scale' | 'mobile-stacked'
    rows?: {
      images?: ILazyBlocksImage[]
    }[]
  }
};

export default function NvisoHorizontalMasonryGallery({ data }: Props) {
  const { enableLines } = useContext(LinesContext);
  const mediaItemIds = Array.from(data.rows?.reduce<Set<number>>((acc, { images }) => {
    images?.forEach((image) => {
      if (typeof image.id === 'number') {
        acc.add(image.id);
      }
    });
    return acc;
  }, new Set()) ?? new Set<number>());
  const mediaItems = useMediaItems(mediaItemIds);
  const entries = (data.rows?.map(({ images }) => (
    flush(images?.map((image) => {
      const imageObject = typeof image.id === 'number' ? mediaItems.get(image.id) : null;
      if (imageObject) {
        return {
          image: {
            src: imageObject.mediaItemUrl ?? '',
            width: imageObject.mediaDetails?.width ?? 120,
            height: imageObject.mediaDetails?.height ?? 120,
          },
        };
      }
      return null;
    }) ?? [])
  )) ?? []);

  return (
    <HorizontalMasonryGallery
      enableLines={enableLines}
      variant={data.variant}
      images={entries}
    />
  );
}
